import { useEffect } from 'react';
import { isVrbo } from 'stores/context-store-utils';
export default function useSecondaryFetchStatus({
  searchResults,
  analytics,
  context,
  multiItem,
  uiPage,
  experiment,
  analyticsSearch,
  pageLayout
}) {
  const REDUCED_NUMBER_OF_SRP_LISTINGS_IS_SECONDARY_FETCHING = searchResults.isFetchSecondaryListingBatch(context, experiment);
  useEffect(() => {
    if (REDUCED_NUMBER_OF_SRP_LISTINGS_IS_SECONDARY_FETCHING && !searchResults.isLoading && !searchResults.isSecondaryFetchDisabled && analytics && multiItem && uiPage && analyticsSearch) {
      const size = searchResults.getSecondaryListingFetchCount(context, experiment);
      const startingIndex = searchResults.getInitialListingFetchCount(context, experiment);
      searchResults.showItemsByPage(analytics, context, multiItem, uiPage, {
        size,
        startingIndex
      }, analyticsSearch, experiment, pageLayout, false, true);
    }
  }, [REDUCED_NUMBER_OF_SRP_LISTINGS_IS_SECONDARY_FETCHING, analytics, analyticsSearch, context, experiment, isVrbo, multiItem, searchResults, uiPage, pageLayout]);
  return REDUCED_NUMBER_OF_SRP_LISTINGS_IS_SECONDARY_FETCHING && searchResults.isPaginationLoading && !isVrbo(context);
}